<template>
  <div v-loading="loading" class="talent-matrix">
    <div v-if="matrix.setting.productivity_size && matrix.setting.potential_size">
      <div class="header-actions">
        <div class="filters" >
          <user-group-select
            v-if="$canAndRulesPass(user, $permissions.GROUP.LIST)"
            v-model="filters.group_ids"
            size="size"
            @selected="loadAxisUserPositions"
            style="margin: 0 20px 10px 0"
          ></user-group-select>
          <user-unique-prop-values-select
            placeholder="Должность"
            v-model="filters.positions"
            prop="position"
            multiple
            @selected="loadAxisUserPositions"
            style="margin: 0 20px 10px 0"
          ></user-unique-prop-values-select>
          <user-unique-prop-values-select
            placeholder="Компания"
            v-model="filters.companies"
            prop="company"
            multiple
            @selected="loadAxisUserPositions"
            style="margin: 0 20px 10px 0"
          ></user-unique-prop-values-select>
          <user-unique-prop-values-select
            placeholder="Подразделение"
            v-model="filters.subdivisions"
            prop="subdivision"
            multiple
            @selected="loadAxisUserPositions"
            style="margin: 0 20px 10px 0"
          ></user-unique-prop-values-select>
          <el-button
            style="margin: 0 20px 10px 0"
            type="primary"
            size="small"
            icon="fas fa-download"
            @click="generatePng()"
          >
            Выгрузить в PNG
          </el-button>
        </div>
        <div slot="right">
          <div class="el-row--flex">
            <el-popconfirm
              v-if="$canAndRulesPass(matrix, 'talent_matrix.matrix_update')"
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите Рассчитать матрицу?"
              @confirm="recalculateMatrix()"
            >
              <el-button
                slot="reference"
                type="primary"
                size="small"
                icon="fas fa-sync-alt"
              >
              </el-button>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <div ref="pngContent" v-if="matrix && matrix.cells && matrix.setting" class="matrix-block">
        <p class="potential_side">Потенциал <span>&#8594;</span></p>
        <p class="productivity_side">Производительность <span>&#8594;</span></p>
        <div class="matrix" v-loading="loading">
          <div v-for="i in matrix.setting.potential_size" :key="'row-' + i" class="row">
            <div
              v-for="j in matrix.setting.productivity_size"
              v-if="getCell(i, j)"
              :key="'cell-' + i + '-' + j"
              class="cell"
              :style="{'background-color': getCell(i, j).color}"
            >
              <div class="header-cell">
                <div class="description-cell">
                  <div class="name">
                    <collapse-text-with-tooltip
                      :text="getCell(i, j).name"
                      :maxLength="getSizeName()"
                      trigger="click"
                    ></collapse-text-with-tooltip>
                  </div>
                  <el-popover
                    v-if="getCell(i, j).description !== ''"
                    placement="top"
                    trigger="click"
                  >
                    <el-button
                      slot="reference"
                      style="margin-left:10px"
                      class="table-action-button danger"
                      type="text"
                      round
                      size="mini"
                      icon="fas fa-info-circle"
                    ></el-button>
                    <div>{{ getCell(i, j).description }}</div>
                  </el-popover>
                </div>
              </div>
              <div class="percent" v-if="getCellStats(getCell(i, j).id).percentage">{{ getCellStats(getCell(i, j).id).percentage }}%</div>
              <div class="users-counter" v-if="getCellStats(getCell(i, j).id).count" @click="openCellUserInformationDialog(getCell(i, j))">
                Пользователи: {{ getCellStats(getCell(i, j).id).count }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p style="text-align: center; color: #909399; font-weight: bold">
        Невозможно построить матрицу, пока не выбран ее размер.<br>
        Потенциал (ось Y) и Производительность (ось X).
      </p>
    </div>
    <talent-matrix-cell-user-information-dialog
      ref="cellUserInformationDialog"
    >
    </talent-matrix-cell-user-information-dialog>
  </div>
</template>

<script>
import TalentMatrixCellUserInformationDialog from "@/modules/talentMatrix/components/TalentMatrixCellUserInformationDialog.vue";
import CollapseTextWithTooltip from "@/components/CollapseTextWithTooltip.vue";
import UserGroupSelect from "@/components/filters/users/UserGroupSelect.vue";
import UserUniquePropValuesSelect from "@/components/filters/users/UserUniquePropValuesSelect.vue";
import {mapGetters} from "vuex";

export default {
  name: 'talent-matrix-view',
  components: {
    TalentMatrixCellUserInformationDialog,
    UserUniquePropValuesSelect,
    CollapseTextWithTooltip,
    UserGroupSelect,
  },
  props: {
    matrix: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      matrix_data: [],
      filters: {
        positions: [],
        group_ids: [],
        companies: [],
        subdivisions: [],
      },
    }
  },
  mounted() {
    this.loadAxisUserPositions();
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    generatePng() {
      const element = this.$refs.pngContent
      import('html2canvas').then(html2canvas => {
        html2canvas.default(element, {
          scale: 2,
          useCORS: true,
          scrollY: 0
        }).then(originalCanvas => {
          const padding = 40;
          const canvas = document.createElement('canvas');
          canvas.width = originalCanvas.width + padding * 2;
          canvas.height = originalCanvas.height + padding * 2;
          const ctx = canvas.getContext('2d');

          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(originalCanvas, padding, padding);

          const link = document.createElement('a');
          link.download = 'Матрица талантов ' + this.matrix.name + '.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
        })
      })
    },
    openCellUserInformationDialog(cell = {}) {
      this.$refs.cellUserInformationDialog.open(cell, this.filters);
    },
    getCell(i, j) {
      return this.matrix.cells.find(
        (item) => item.row === i && item.column === j
      );
    },
    getCellStats(cellId) {
      return this.matrix_data[cellId] || { count: 0, percentage: 0 };
    },
    getSizeName() {
      if (this.matrix.setting.potential_size < 2) {
        return 100;
      } else if (this.matrix.setting.potential_size < 3) {
        return 60;
      } else if (this.matrix.setting.potential_size < 4) {
        return 40;
      } else if (this.matrix.setting.potential_size < 5) {
        return 30;
      }
    },
    recalculateMatrix() {
      this.loading = true;
      this.$api.talentMatrix.matrixCalculate({
        id: this.$route.params.id,
      })
        .then(data => {
          this.$notify.success({
            title: 'Успех',
            message: 'Матрица успешно рассчитана'
          });

          this.loadAxisUserPositions();
          this.$emit('load-axis-user-positions');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadAxisUserPositions() {
      this.loading = true;
      this.$api.talentMatrix.matrixCellUserPositionsSearch({
        matrix_id: this.matrix.id,
        ...this.filters,
        expand: ['user', 'cell'].join()
      })
        .then(data => {
          this.matrix_data = data.matrix_data;
        })
        .finally(() => {
          this.loading = false;
        })
    },
  },
}
</script>

<style scoped>
  .talent-matrix {
    .header-actions {
      padding: 0 35px;
      display: flex;
      justify-content: space-between;
    }

    .row {
      display: flex;
    }

    .description-cell {
      display: flex;
      align-items: center;
    }

    .matrix {
      overflow: auto;
    }

    .cell {
      box-shadow: rgba(0, 0, 0, 0.1) 0 0 10px;
      border: 1px solid rgb(225, 225, 225);
      width: 100%;
      height: 100%;
      min-width: 250px;
      min-height: 200px;
      margin: 10px;
      background-color: white;
      border-radius: 7px;
      position: relative;
    }

    .name {
      cursor: pointer;
      font-size: 15px;
    }

    .header-cell {
      min-height: 28px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #EBEEF5;
      background-color: rgba(255, 255, 255, 0.7);
      padding: 5px 10px;
    }

    .matrix-block {
      margin: 25px;
      position: relative;
    }

    .potential_side span,
    .productivity_side span {
      font-size: 36px;
      font-weight: bold;
    }

    .potential_side {
      color: #9a9a9a;
      position: absolute;
      left: -107px;
      bottom: 47px;
      transform: rotate(-90deg);
      font-size: 25px;
    }

    .productivity_side {
      color: #9a9a9a;
      position: absolute;
      bottom: -60px;
      font-size: 25px;
      left: 14px;
    }

    .percent {
      border: 1px solid #EBEEF5;
      background-color: rgba(255, 255, 255, 0.7);
      padding: 7px;
      border-radius: 7px;
      font-size: 20px;
      font-weight: bold;
      width: 50px;
      text-align: center;
      position: absolute;
      top: 55px;
      right: 15px;
    }

    .users-counter {
      border: 1px solid #EBEEF5;
      background-color: rgba(255, 255, 255, 0.7);
      padding: 7px;
      border-radius: 7px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      position: absolute;
      bottom: 15px;
      left: 15px;
      cursor: pointer;
    }
  }
</style>
